import store from './index'

const getters = {
  sidebar: state => state.app.sidebar,
  permission_routes: state => state.permission.routes,
  buttonResKey: state => state.permission.buttonResKey,
  rootMenuStyle: state => state.permission.rootMenuStyle,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  // projectArr: state => state.user.projectArr,
  projectArr: state => {
    if (state.common.projectArr.length === 0) {
      store.dispatch('common/setProjectArr')
    }
    return state.common.projectArr
  },
  departmentArr: state => state.common.departmentArr,
  roleArr: state => state.common.roleArr,
  outletList: state => state.common.outletList,
  categoryArr: state => state.common.categoryArr,
  goodsAttrArr: state => state.common.goodsAttrArr,
  goodsArr: state => state.common.goodsArr,
  design: state => state.common.design,
  previewVisible: state => state.mediaPreview.previewVisible,
  mediaPreviewOption: state => state.mediaPreview.mediaPreviewOption,
  booUserPlatform: () => true, // 园区端
  currentParkId: state => state.user.loginUserInfo.currentParkId, // 当前的园区,也可能为空,没有企业的时候就没有园区
  currentParkName: state => state.user.loginUserInfo.currentParkName,
  userId: state => state.user.userId
}
export default getters
